module.exports = __webpack_public_path__ + "static/01-bef3bb1e235d81ea5c76b3d1e6ba4845.jpg";